import { useState, useEffect } from "react";

const BRAND = "Trym";
const DOMAIN = "trym.click";
const REVENUE_SHARE_PCT = 0.60;

const uid = () => Math.random().toString(36).slice(2, 8);
const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const currency = (n) => "$" + n.toFixed(2);
const pct = (n) => (n * 100).toFixed(1) + "%";
const fmtNum = (n) => n.toLocaleString();
const ago = (d) => {
  const s = Math.floor((Date.now() - d) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return Math.floor(s / 60) + "m ago";
  if (s < 86400) return Math.floor(s / 3600) + "h ago";
  return Math.floor(s / 86400) + "d ago";
};
const fmtDate = (d) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
const sparkData = () => Array.from({ length: 14 }, () => rand(20, 100));

const seedLinks = () => [
  {
    id: uid(), slug: "best-vpn", tag: "vpn", active: true,
    created: Date.now() - 86400000 * 12,
    destinations: [
      { url: "https://nordvpn.com/deal?ref=YOU123", label: "NordVPN", weight: 50 },
      { url: "https://expressvpn.com/deal?ref=YOU456", label: "ExpressVPN", weight: 30 },
      { url: "https://surfshark.com/deal?ref=YOU789", label: "Surfshark", weight: 20 },
    ],
    rotationMode: "weighted",
    smartRedirects: {
      enabled: true,
      mobile: "https://apps.apple.com/app/nordvpn/id905953485",
      desktop: "https://nordvpn.com/deal?ref=YOU123",
      tablet: "",
    },
    expiry: { enabled: false, maxClicks: null, expiresAt: null },
    password: null,
    clicks: 4832, uniqueClicks: 3291, conversions: 187,
    totalAdRevenue: 2420.00,
    userEarnings: 1452.00,
    platformEarnings: 968.00,
    destStats: [
      { url: "https://nordvpn.com/deal?ref=YOU123", clicks: 2416, conversions: 102, earnings: 816.00 },
      { url: "https://expressvpn.com/deal?ref=YOU456", clicks: 1450, conversions: 54, earnings: 432.00 },
      { url: "https://surfshark.com/deal?ref=YOU789", clicks: 966, conversions: 31, earnings: 204.00 },
    ],
    geo: { US: 42, UK: 18, CA: 12, DE: 8, AU: 6, Other: 14 },
    devices: { Mobile: 58, Desktop: 34, Tablet: 8 },
    recentClicks: [Date.now() - 120000, Date.now() - 340000, Date.now() - 890000, Date.now() - 2400000, Date.now() - 5600000],
  },
  {
    id: uid(), slug: "hosting-deal", tag: "hosting", active: true,
    created: Date.now() - 86400000 * 8,
    destinations: [
      { url: "https://bluehost.com/special?aff=YOU789", label: "Bluehost", weight: 60 },
      { url: "https://siteground.com/go?aff=YOU101", label: "SiteGround", weight: 40 },
    ],
    rotationMode: "weighted",
    smartRedirects: { enabled: false, mobile: "", desktop: "", tablet: "" },
    expiry: { enabled: true, maxClicks: 10000, expiresAt: Date.now() + 86400000 * 14 },
    password: null,
    clicks: 2910, uniqueClicks: 2104, conversions: 93,
    totalAdRevenue: 1937.50,
    userEarnings: 1162.50,
    platformEarnings: 775.00,
    destStats: [
      { url: "https://bluehost.com/special?aff=YOU789", clicks: 1746, conversions: 61, earnings: 762.50 },
      { url: "https://siteground.com/go?aff=YOU101", clicks: 1164, conversions: 32, earnings: 400.00 },
    ],
    geo: { US: 55, UK: 12, IN: 10, CA: 8, AU: 5, Other: 10 },
    devices: { Mobile: 44, Desktop: 48, Tablet: 8 },
    recentClicks: [Date.now() - 60000, Date.now() - 180000, Date.now() - 720000, Date.now() - 3600000],
  },
  {
    id: uid(), slug: "ai-tool", tag: "ai", active: true,
    created: Date.now() - 86400000 * 5,
    destinations: [{ url: "https://jasper.ai/try?via=YOU101", label: "Jasper AI", weight: 100 }],
    rotationMode: "single",
    smartRedirects: {
      enabled: true,
      mobile: "https://apps.apple.com/app/jasper-ai/id123456",
      desktop: "https://jasper.ai/try?via=YOU101",
      tablet: "",
    },
    expiry: { enabled: false, maxClicks: null, expiresAt: null },
    password: "vip2026",
    clicks: 1567, uniqueClicks: 1203, conversions: 42,
    totalAdRevenue: 840.00,
    userEarnings: 504.00,
    platformEarnings: 336.00,
    destStats: [
      { url: "https://jasper.ai/try?via=YOU101", clicks: 1567, conversions: 42, earnings: 504.00 },
    ],
    geo: { US: 38, UK: 15, CA: 10, DE: 9, FR: 7, Other: 21 },
    devices: { Mobile: 51, Desktop: 40, Tablet: 9 },
    recentClicks: [Date.now() - 200000, Date.now() - 900000, Date.now() - 4500000],
  },
  {
    id: uid(), slug: "email-mktg", tag: "email", active: false,
    created: Date.now() - 86400000 * 3,
    destinations: [{ url: "https://convertkit.com?lmref=YOU202", label: "ConvertKit", weight: 100 }],
    rotationMode: "single",
    smartRedirects: { enabled: false, mobile: "", desktop: "", tablet: "" },
    expiry: { enabled: true, maxClicks: 500, expiresAt: Date.now() - 86400000 },
    password: null,
    clicks: 891, uniqueClicks: 702, conversions: 28,
    totalAdRevenue: 560.00,
    userEarnings: 336.00,
    platformEarnings: 224.00,
    destStats: [
      { url: "https://convertkit.com?lmref=YOU202", clicks: 891, conversions: 28, earnings: 336.00 },
    ],
    geo: { US: 60, UK: 14, CA: 9, AU: 7, Other: 10 },
    devices: { Mobile: 39, Desktop: 52, Tablet: 9 },
    recentClicks: [Date.now() - 7200000],
  },
];

const Spark = ({ data, color = "#22c55e", h = 32, w = 80 }) => {
  const max = Math.max(...data);
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * w},${h - (v / max) * (h - 4) - 2}`).join(" ");
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} style={{ display: "block" }}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const MiniBar = ({ label, value, max = 100, color }) => (
  <div style={{ marginBottom: 7 }}>
    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#94a3b8", marginBottom: 2 }}>
      <span>{label}</span><span>{value}%</span>
    </div>
    <div style={{ height: 5, background: "#1e293b", borderRadius: 3 }}>
      <div style={{ height: 5, width: `${(value / max) * 100}%`, background: color || "#22c55e", borderRadius: 3, transition: "width 0.6s ease" }} />
    </div>
  </div>
);

const Badge = ({ children, color = "#22c55e" }) => (
  <span style={{
    display: "inline-block", padding: "2px 8px", borderRadius: 4,
    fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
    background: color + "18", color, textTransform: "uppercase", whiteSpace: "nowrap",
  }}>{children}</span>
);

const StatCard = ({ label, value, sub, icon, accent = "#22c55e", spark }) => (
  <div style={{
    background: "linear-gradient(135deg, #0f172a 0%, #1a1f35 100%)",
    border: "1px solid #1e293b", borderRadius: 12, padding: "18px 20px",
    position: "relative", overflow: "hidden", minWidth: 0,
  }}>
    <div style={{ position: "absolute", top: 12, right: 14, fontSize: 20, opacity: 0.15 }}>{icon}</div>
    <div style={{ fontSize: 10, color: "#64748b", fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", marginBottom: 6 }}>{label}</div>
    <div style={{ fontSize: 24, fontWeight: 800, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>{value}</div>
    {sub && <div style={{ fontSize: 11, color: accent, marginTop: 3, fontWeight: 600 }}>{sub}</div>}
    {spark && <div style={{ marginTop: 8 }}><Spark data={spark} color={accent} w={100} h={26} /></div>}
  </div>
);

const TabBtn = ({ active, children, onClick }) => (
  <button onClick={onClick} style={{
    padding: "8px 16px", borderRadius: 8, border: "none", cursor: "pointer",
    fontSize: 12, fontWeight: 600, transition: "all 0.2s", whiteSpace: "nowrap",
    background: active ? "#22c55e" : "transparent",
    color: active ? "#020617" : "#64748b",
  }}>{children}</button>
);

const Input = ({ label, value, onChange, placeholder, mono, type = "text" }) => (
  <div style={{ marginBottom: 14 }}>
    <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", marginBottom: 5, letterSpacing: 0.5, textTransform: "uppercase" }}>{label}</div>
    <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} type={type}
      style={{
        width: "100%", padding: "9px 12px", borderRadius: 8,
        background: "#020617", border: "1px solid #1e293b", color: "#e2e8f0",
        fontSize: 12, fontFamily: mono ? "'JetBrains Mono', monospace" : "inherit", outline: "none",
        boxSizing: "border-box", transition: "border-color 0.2s",
      }}
      onFocus={(e) => (e.target.style.borderColor = "#22c55e60")}
      onBlur={(e) => (e.target.style.borderColor = "#1e293b")}
    />
  </div>
);

const Toggle = ({ label, checked, onChange, color = "#22c55e" }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, cursor: "pointer" }} onClick={() => onChange(!checked)}>
    <div style={{
      width: 36, height: 20, borderRadius: 10, padding: 2,
      background: checked ? color : "#1e293b", transition: "background 0.2s",
      display: "flex", alignItems: "center",
    }}>
      <div style={{
        width: 16, height: 16, borderRadius: 8, background: "#f1f5f9",
        transform: checked ? "translateX(16px)" : "translateX(0)",
        transition: "transform 0.2s", boxShadow: "0 1px 3px #00000040",
      }} />
    </div>
    <span style={{ fontSize: 12, fontWeight: 600, color: checked ? "#e2e8f0" : "#64748b" }}>{label}</span>
  </div>
);

const FeaturePill = ({ icon, label, color }) => (
  <span style={{
    display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 9px",
    borderRadius: 6, fontSize: 10, fontWeight: 700,
    background: color + "14", color, border: `1px solid ${color}30`,
  }}>{icon} {label}</span>
);

const SectionCard = ({ children, title, icon, accent, style: s }) => (
  <div style={{
    background: "#0f172a", border: "1px solid #1e293b", borderRadius: 12, padding: 20, ...s,
  }}>
    {title && (
      <div style={{ fontSize: 13, fontWeight: 700, color: accent || "#f1f5f9", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
        {icon} {title}
      </div>
    )}
    {children}
  </div>
);

export default function LinkForge() {
  const [links, setLinks] = useState(seedLinks);
  const [tab, setTab] = useState("dashboard");
  const [selectedLink, setSelectedLink] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState(null);
  const [liveCounter, setLiveCounter] = useState(0);

  const [cSlug, setCSlug] = useState("");
  const [cTag, setCTag] = useState("");
  const [cDests, setCDests] = useState([{ url: "", label: "", weight: 100 }]);
  const [cRotation, setCRotation] = useState("single");
  const [cSmartEnabled, setCSmartEnabled] = useState(false);
  const [cSmartMobile, setCSmartMobile] = useState("");
  const [cSmartDesktop, setCSmartDesktop] = useState("");
  const [cExpiryEnabled, setCExpiryEnabled] = useState(false);
  const [cMaxClicks, setCMaxClicks] = useState("");
  const [cExpiryDate, setCExpiryDate] = useState("");
  const [cPassword, setCPassword] = useState("");

  const resetForm = () => {
    setCSlug(""); setCTag(""); setCDests([{ url: "", label: "", weight: 100 }]);
    setCRotation("single"); setCSmartEnabled(false); setCSmartMobile("");
    setCSmartDesktop(""); setCExpiryEnabled(false); setCMaxClicks("");
    setCExpiryDate(""); setCPassword("");
  };

  useEffect(() => {
    const iv = setInterval(() => {
      setLiveCounter((c) => c + rand(1, 4));
      setLinks((prev) =>
        prev.map((l) =>
          l.active && Math.random() > 0.4
            ? { ...l, clicks: l.clicks + 1, recentClicks: [Date.now(), ...l.recentClicks.slice(0, 14)] }
            : l
        )
      );
    }, 3000);
    return () => clearInterval(iv);
  }, []);

  const totalClicks = links.reduce((s, l) => s + l.clicks, 0);
  const totalUserEarnings = links.reduce((s, l) => s + l.userEarnings, 0);
  const totalPlatformEarnings = links.reduce((s, l) => s + l.platformEarnings, 0);
  const totalAdRevenue = links.reduce((s, l) => s + l.totalAdRevenue, 0);
  const totalConversions = links.reduce((s, l) => s + l.conversions, 0);
  const avgCvr = totalClicks > 0 ? totalConversions / totalClicks : 0;

  const handleCreate = () => {
    const validDests = cDests.filter((d) => d.url);
    if (!validDests.length) return;
    const link = {
      id: uid(), slug: cSlug || uid(), tag: cTag || "general", active: true,
      created: Date.now(),
      destinations: validDests.map((d) => ({ ...d, weight: Number(d.weight) || 100 })),
      rotationMode: validDests.length > 1 ? cRotation : "single",
      smartRedirects: { enabled: cSmartEnabled, mobile: cSmartMobile, desktop: cSmartDesktop, tablet: "" },
      expiry: {
        enabled: cExpiryEnabled,
        maxClicks: cMaxClicks ? Number(cMaxClicks) : null,
        expiresAt: cExpiryDate ? new Date(cExpiryDate).getTime() : null,
      },
      password: cPassword || null,
      clicks: 0, uniqueClicks: 0, conversions: 0,
      totalAdRevenue: 0, userEarnings: 0, platformEarnings: 0,
      destStats: validDests.map((d) => ({ url: d.url, clicks: 0, conversions: 0, earnings: 0 })),
      geo: {}, devices: { Mobile: 0, Desktop: 0, Tablet: 0 }, recentClicks: [],
    };
    setLinks([link, ...links]);
    resetForm();
    setShowCreate(false);
  };

  const copyLink = (slug) => {
    navigator.clipboard?.writeText(`${DOMAIN}/${slug}`);
    setCopyFeedback(slug);
    setTimeout(() => setCopyFeedback(null), 1500);
  };

  const toggleLinkActive = (id) => {
    setLinks((prev) => prev.map((l) => (l.id === id ? { ...l, active: !l.active } : l)));
  };

  const detail = selectedLink ? links.find((l) => l.id === selectedLink) : null;

  const isExpired = (l) => {
    if (!l.expiry.enabled) return false;
    if (l.expiry.maxClicks && l.clicks >= l.expiry.maxClicks) return true;
    if (l.expiry.expiresAt && Date.now() > l.expiry.expiresAt) return true;
    return false;
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#020617", color: "#e2e8f0",
      fontFamily: "'Outfit', 'Inter', system-ui, sans-serif",
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700;800;900&family=JetBrains+Mono:wght@400;600;700;800&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <div style={{
        borderBottom: "1px solid #1e293b",
        background: "linear-gradient(180deg, #0a0f1e 0%, #020617 100%)",
        padding: "14px 24px", display: "flex", alignItems: "center", justifyContent: "space-between",
        flexWrap: "wrap", gap: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 34, height: 34, borderRadius: 8,
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 17, fontWeight: 900, color: "#020617",
          }}>⚡</div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: -0.5, color: "#f8fafc" }}>{BRAND}</div>
            <div style={{ fontSize: 9, color: "#22c55e", fontWeight: 600, letterSpacing: 2, textTransform: "uppercase" }}>Shorten · Track · Earn</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "5px 12px", borderRadius: 20,
            background: "#22c55e12", border: "1px solid #22c55e30",
          }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e", animation: "pulse 2s infinite" }} />
            <span style={{ fontSize: 11, color: "#22c55e", fontWeight: 700, fontFamily: "'JetBrains Mono', monospace" }}>
              {fmtNum(totalClicks + liveCounter)} clicks
            </span>
          </div>
          <div style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "5px 12px", borderRadius: 20,
            background: "#f59e0b12", border: "1px solid #f59e0b30",
          }}>
            <span style={{ fontSize: 11, color: "#f59e0b", fontWeight: 700, fontFamily: "'JetBrains Mono', monospace" }}>
              {currency(totalUserEarnings)} earned
            </span>
          </div>
          <button onClick={() => { resetForm(); setShowCreate(true); }} style={{
            padding: "7px 18px", borderRadius: 8, border: "none", cursor: "pointer",
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            color: "#020617", fontSize: 12, fontWeight: 700,
            boxShadow: "0 0 20px #22c55e30",
          }}>+ New Link</button>
        </div>
      </div>

      {/* TABS */}
      <div style={{ padding: "10px 24px 0", display: "flex", gap: 4, flexWrap: "wrap" }}>
        {[
          ["dashboard", "📊 Dashboard"],
          ["links", "🔗 Links"],
          ["earnings", "💰 Earnings"],
          ["revenue", "🤝 Revenue Share"],
        ].map(([t, label]) => (
          <TabBtn key={t} active={tab === t} onClick={() => { setTab(t); setSelectedLink(null); }}>{label}</TabBtn>
        ))}
      </div>

      <div style={{ padding: "18px 24px 40px" }}>

        {/* DASHBOARD */}
        {tab === "dashboard" && (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 14, marginBottom: 20 }}>
              <StatCard label="Total Clicks" value={fmtNum(totalClicks)} sub={`+${rand(80, 300)} today`} icon="🖱️" spark={sparkData()} />
              <StatCard label="Your Earnings" value={currency(totalUserEarnings)} sub={`${pct(REVENUE_SHARE_PCT)} rev share`} icon="💵" accent="#f59e0b" spark={sparkData()} />
              <StatCard label="Conversions" value={fmtNum(totalConversions)} sub={pct(avgCvr) + " CVR"} icon="🎯" accent="#8b5cf6" spark={sparkData()} />
              <StatCard label="Active Links" value={links.filter((l) => l.active && !isExpired(l)).length} sub={`${links.length} total`} icon="🔗" accent="#06b6d4" />
            </div>

            <SectionCard title="Top Performing Links" icon="🏆">
              {[...links].sort((a, b) => b.userEarnings - a.userEarnings).slice(0, 4).map((l, i) => (
                <div key={l.id} style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "11px 0", borderBottom: i < 3 ? "1px solid #1e293b" : "none",
                  flexWrap: "wrap", gap: 8,
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                    <div style={{
                      width: 26, height: 26, borderRadius: 6, flexShrink: 0,
                      background: i === 0 ? "#f59e0b20" : "#1e293b",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 13, fontWeight: 800, color: i === 0 ? "#f59e0b" : "#64748b",
                    }}>{i + 1}</div>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0", fontFamily: "'JetBrains Mono', monospace" }}>
                          {DOMAIN}/{l.slug}
                        </span>
                        {l.destinations.length > 1 && <FeaturePill icon="🔄" label="Rotation" color="#06b6d4" />}
                        {l.smartRedirects.enabled && <FeaturePill icon="📱" label="Smart" color="#8b5cf6" />}
                        {l.password && <FeaturePill icon="🔒" label="Protected" color="#f59e0b" />}
                        {l.expiry.enabled && <FeaturePill icon="⏳" label={isExpired(l) ? "Expired" : "Expiring"} color={isExpired(l) ? "#ef4444" : "#f59e0b"} />}
                      </div>
                      <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>
                        {fmtNum(l.clicks)} clicks · {l.conversions} conv · {l.destinations.length} dest{l.destinations.length > 1 ? "s" : ""}
                      </div>
                    </div>
                  </div>
                  <div style={{ fontSize: 17, fontWeight: 800, color: "#22c55e", fontFamily: "'JetBrains Mono', monospace" }}>
                    {currency(l.userEarnings)}
                  </div>
                </div>
              ))}
            </SectionCard>

            <SectionCard title="Live Click Feed" icon={<div style={{ width: 7, height: 7, borderRadius: "50%", background: "#22c55e", animation: "pulse 2s infinite" }} />} style={{ marginTop: 14 }}>
              {links.flatMap((l) => l.recentClicks.slice(0, 3).map((t) => ({ slug: l.slug, tag: l.tag, time: t, dests: l.destinations.length })))
                .sort((a, b) => b.time - a.time).slice(0, 6).map((c, i) => (
                  <div key={i} style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "7px 0", borderBottom: i < 5 ? "1px solid #0f1a2e" : "none", fontSize: 12,
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ color: "#22c55e" }}>●</span>
                      <span style={{ color: "#94a3b8", fontFamily: "'JetBrains Mono', monospace" }}>{DOMAIN}/{c.slug}</span>
                      <Badge>{c.tag}</Badge>
                      {c.dests > 1 && <Badge color="#06b6d4">{c.dests} dests</Badge>}
                    </div>
                    <span style={{ color: "#475569", fontSize: 11 }}>{ago(c.time)}</span>
                  </div>
                ))}
            </SectionCard>
          </div>
        )}

        {/* LINKS LIST */}
        {tab === "links" && !detail && (
          <div>
            {links.map((l) => {
              const expired = isExpired(l);
              return (
                <div key={l.id} onClick={() => setSelectedLink(l.id)} style={{
                  background: "#0f172a", border: `1px solid ${expired ? "#ef444430" : "#1e293b"}`, borderRadius: 12,
                  padding: "16px 20px", marginBottom: 10, cursor: "pointer", transition: "border-color 0.2s",
                  opacity: expired ? 0.65 : 1,
                }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = expired ? "#ef444460" : "#22c55e40")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = expired ? "#ef444430" : "#1e293b")}
                >
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>
                          {DOMAIN}/{l.slug}
                        </span>
                        <Badge color={l.active && !expired ? "#22c55e" : "#ef4444"}>{expired ? "Expired" : l.active ? "Active" : "Paused"}</Badge>
                        <Badge>{l.tag}</Badge>
                      </div>
                      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 6 }}>
                        {l.destinations.length > 1 && <FeaturePill icon="🔄" label={`${l.destinations.length} URLs · ${l.rotationMode}`} color="#06b6d4" />}
                        {l.smartRedirects.enabled && <FeaturePill icon="📱" label="Smart Redirect" color="#8b5cf6" />}
                        {l.password && <FeaturePill icon="🔒" label="Password" color="#f59e0b" />}
                        {l.expiry.enabled && (
                          <FeaturePill icon="⏳" label={
                            expired ? "Expired" :
                              l.expiry.maxClicks ? `${fmtNum(l.expiry.maxClicks - l.clicks)} clicks left` :
                                l.expiry.expiresAt ? `Expires ${fmtDate(l.expiry.expiresAt)}` : "Expiring"
                          } color={expired ? "#ef4444" : "#f59e0b"} />
                        )}
                      </div>
                      <div style={{ fontSize: 11, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 380 }}>
                        → {l.destinations[0].url}{l.destinations.length > 1 ? ` (+${l.destinations.length - 1} more)` : ""}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>{fmtNum(l.clicks)}</div>
                        <div style={{ fontSize: 10, color: "#64748b" }}>clicks</div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#22c55e", fontFamily: "'JetBrains Mono', monospace" }}>{currency(l.userEarnings)}</div>
                        <div style={{ fontSize: 10, color: "#64748b" }}>your share</div>
                      </div>
                      <button onClick={(e) => { e.stopPropagation(); copyLink(l.slug); }} style={{
                        padding: "5px 12px", borderRadius: 6, border: "1px solid #1e293b",
                        background: copyFeedback === l.slug ? "#22c55e20" : "#0f172a",
                        color: copyFeedback === l.slug ? "#22c55e" : "#94a3b8",
                        fontSize: 11, fontWeight: 600, cursor: "pointer", transition: "all 0.2s",
                      }}>
                        {copyFeedback === l.slug ? "✓ Copied" : "Copy"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* LINK DETAIL */}
        {tab === "links" && detail && (
          <div>
            <button onClick={() => setSelectedLink(null)} style={{
              background: "none", border: "none", color: "#64748b", fontSize: 12,
              cursor: "pointer", marginBottom: 14, padding: 0, fontWeight: 600,
            }}>← Back to all links</button>

            <SectionCard style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 10, marginBottom: 16 }}>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#f8fafc", fontFamily: "'JetBrains Mono', monospace" }}>
                    {DOMAIN}/{detail.slug}
                  </div>
                  <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginTop: 6 }}>
                    <Badge color={detail.active && !isExpired(detail) ? "#22c55e" : "#ef4444"}>
                      {isExpired(detail) ? "Expired" : detail.active ? "Active" : "Paused"}
                    </Badge>
                    {detail.destinations.length > 1 && <FeaturePill icon="🔄" label={`Rotation · ${detail.rotationMode}`} color="#06b6d4" />}
                    {detail.smartRedirects.enabled && <FeaturePill icon="📱" label="Smart Redirect" color="#8b5cf6" />}
                    {detail.password && <FeaturePill icon="🔒" label="Password Protected" color="#f59e0b" />}
                    {detail.expiry.enabled && <FeaturePill icon="⏳" label={isExpired(detail) ? "Expired" : "Expiring"} color={isExpired(detail) ? "#ef4444" : "#f59e0b"} />}
                  </div>
                </div>
                <button onClick={() => toggleLinkActive(detail.id)} style={{
                  padding: "6px 16px", borderRadius: 6, border: "1px solid #1e293b",
                  background: detail.active ? "#ef444420" : "#22c55e20",
                  color: detail.active ? "#ef4444" : "#22c55e",
                  fontSize: 11, fontWeight: 700, cursor: "pointer",
                }}>{detail.active ? "Pause Link" : "Activate Link"}</button>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", gap: 10 }}>
                {[
                  { label: "Total Clicks", val: fmtNum(detail.clicks), color: "#f1f5f9" },
                  { label: "Unique Clicks", val: fmtNum(detail.uniqueClicks), color: "#f1f5f9" },
                  { label: "Conversions", val: detail.conversions, color: "#8b5cf6" },
                  { label: "Your Earnings", val: currency(detail.userEarnings), color: "#22c55e" },
                  { label: "Ad Revenue", val: currency(detail.totalAdRevenue), color: "#f59e0b" },
                ].map((s) => (
                  <div key={s.label} style={{ background: "#020617", borderRadius: 8, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: s.color, fontFamily: "'JetBrains Mono', monospace" }}>{s.val}</div>
                    <div style={{ fontSize: 9, color: "#64748b", marginTop: 3, textTransform: "uppercase", letterSpacing: 0.5 }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </SectionCard>

            {/* ROTATION */}
            <SectionCard title={`Destination Rotation · ${detail.rotationMode} mode`} icon="🔄" accent="#06b6d4" style={{ marginBottom: 14 }}>
              {detail.destinations.length > 1 && (
                <div style={{ fontSize: 11, color: "#64748b", marginBottom: 12, marginTop: -8 }}>
                  Traffic is split across {detail.destinations.length} URLs. {detail.rotationMode === "weighted" ? "Higher-weight URLs get more traffic." : detail.rotationMode === "sequential" ? "URLs are served in order." : "URLs are served randomly."}
                </div>
              )}
              {detail.destStats.map((ds, i) => {
                const dest = detail.destinations[i];
                const pctOfClicks = detail.clicks > 0 ? ds.clicks / detail.clicks : 0;
                const cvr = ds.clicks > 0 ? ds.conversions / ds.clicks : 0;
                const isBest = detail.destStats.length > 1 && ds.earnings === Math.max(...detail.destStats.map((d) => d.earnings));
                return (
                  <div key={i} style={{
                    background: "#020617", borderRadius: 10, padding: 14, marginBottom: 8,
                    border: isBest ? "1px solid #22c55e30" : "1px solid #1e293b",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8, flexWrap: "wrap", gap: 6 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0" }}>{dest?.label || `Destination ${i + 1}`}</span>
                        {dest && <Badge color="#06b6d4">Weight: {dest.weight}%</Badge>}
                        {isBest && detail.destStats.length > 1 && <Badge color="#22c55e">Best</Badge>}
                      </div>
                      <span style={{ fontSize: 11, color: "#64748b" }}>{pct(pctOfClicks)} of traffic</span>
                    </div>
                    <div style={{ fontSize: 11, color: "#475569", marginBottom: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      → {ds.url}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, fontSize: 12 }}>
                      <div><div style={{ color: "#64748b", fontSize: 10 }}>Clicks</div><div style={{ fontWeight: 700, color: "#f1f5f9" }}>{fmtNum(ds.clicks)}</div></div>
                      <div><div style={{ color: "#64748b", fontSize: 10 }}>CVR</div><div style={{ fontWeight: 700, color: "#8b5cf6" }}>{pct(cvr)}</div></div>
                      <div><div style={{ color: "#64748b", fontSize: 10 }}>Earnings</div><div style={{ fontWeight: 700, color: "#22c55e" }}>{currency(ds.earnings)}</div></div>
                    </div>
                  </div>
                );
              })}
            </SectionCard>

            {/* SMART REDIRECTS */}
            {detail.smartRedirects.enabled && (
              <SectionCard title="Smart Redirects" icon="📱" accent="#8b5cf6" style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: "#64748b", marginBottom: 12, marginTop: -8 }}>
                  Visitors are automatically routed based on their device type.
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  {[
                    { label: "📱 Mobile", url: detail.smartRedirects.mobile, pctVal: detail.devices.Mobile },
                    { label: "🖥️ Desktop", url: detail.smartRedirects.desktop, pctVal: detail.devices.Desktop },
                  ].filter((r) => r.url).map((r) => (
                    <div key={r.label} style={{ background: "#020617", borderRadius: 8, padding: 12, border: "1px solid #1e293b" }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0", marginBottom: 4 }}>{r.label}</div>
                      <div style={{ fontSize: 10, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginBottom: 6 }}>→ {r.url}</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: "#8b5cf6", fontFamily: "'JetBrains Mono', monospace" }}>{r.pctVal}%</div>
                      <div style={{ fontSize: 9, color: "#64748b" }}>of traffic</div>
                    </div>
                  ))}
                </div>
              </SectionCard>
            )}

            {/* EXPIRY */}
            {detail.expiry.enabled && (
              <SectionCard title={isExpired(detail) ? "Link Expired" : "Expiry Settings"} icon="⏳" accent={isExpired(detail) ? "#ef4444" : "#f59e0b"} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                  {detail.expiry.maxClicks && (
                    <div style={{ background: "#020617", borderRadius: 8, padding: 14, border: "1px solid #1e293b", flex: 1, minWidth: 150 }}>
                      <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, textTransform: "uppercase" }}>Click Limit</div>
                      <div style={{ fontSize: 20, fontWeight: 800, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>
                        {fmtNum(detail.clicks)} / {fmtNum(detail.expiry.maxClicks)}
                      </div>
                      <div style={{ height: 5, background: "#1e293b", borderRadius: 3, marginTop: 8 }}>
                        <div style={{
                          height: 5, borderRadius: 3, transition: "width 0.6s",
                          width: `${Math.min((detail.clicks / detail.expiry.maxClicks) * 100, 100)}%`,
                          background: detail.clicks >= detail.expiry.maxClicks ? "#ef4444" : "#f59e0b",
                        }} />
                      </div>
                    </div>
                  )}
                  {detail.expiry.expiresAt && (
                    <div style={{ background: "#020617", borderRadius: 8, padding: 14, border: "1px solid #1e293b", flex: 1, minWidth: 150 }}>
                      <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, textTransform: "uppercase" }}>Date Expiry</div>
                      <div style={{ fontSize: 16, fontWeight: 800, color: Date.now() > detail.expiry.expiresAt ? "#ef4444" : "#f59e0b", fontFamily: "'JetBrains Mono', monospace" }}>
                        {fmtDate(detail.expiry.expiresAt)}
                      </div>
                      <div style={{ fontSize: 11, color: "#64748b", marginTop: 4 }}>
                        {Date.now() > detail.expiry.expiresAt ? "This link has expired" : `${Math.ceil((detail.expiry.expiresAt - Date.now()) / 86400000)} days remaining`}
                      </div>
                    </div>
                  )}
                </div>
              </SectionCard>
            )}

            {/* PASSWORD */}
            {detail.password && (
              <SectionCard title="Password Protected" icon="🔒" accent="#f59e0b" style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, color: "#94a3b8" }}>
                  Visitors must enter a password before being redirected.
                </div>
                <div style={{
                  marginTop: 10, display: "inline-flex", alignItems: "center", gap: 8,
                  background: "#020617", borderRadius: 8, padding: "8px 14px", border: "1px solid #1e293b",
                }}>
                  <span style={{ fontSize: 11, color: "#64748b" }}>Password:</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#f59e0b", fontFamily: "'JetBrains Mono', monospace" }}>{detail.password}</span>
                </div>
              </SectionCard>
            )}

            {/* Geo + Device */}
            {Object.keys(detail.geo).length > 0 && (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                <SectionCard title="Geo Breakdown" icon="🌍">
                  {Object.entries(detail.geo).map(([k, v]) => (
                    <MiniBar key={k} label={k} value={v} color="#06b6d4" />
                  ))}
                </SectionCard>
                <SectionCard title="Device Breakdown" icon="📱">
                  {Object.entries(detail.devices).map(([k, v]) => (
                    <MiniBar key={k} label={k} value={v} color="#8b5cf6" />
                  ))}
                </SectionCard>
              </div>
            )}
          </div>
        )}

        {/* EARNINGS */}
        {tab === "earnings" && (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 14, marginBottom: 20 }}>
              <StatCard label="Your Earnings" value={currency(totalUserEarnings)} sub="Your 60% share" icon="💰" accent="#22c55e" spark={sparkData()} />
              <StatCard label="Total Ad Revenue" value={currency(totalAdRevenue)} sub="All links combined" icon="📊" accent="#f59e0b" spark={sparkData()} />
              <StatCard label="Avg EPC" value={currency(totalClicks > 0 ? totalUserEarnings / totalClicks : 0)} sub="Earnings per click" icon="🎯" accent="#8b5cf6" />
              <StatCard label="This Month" value={currency(totalUserEarnings * 0.38)} sub={`+${pct(0.12)} vs last month`} icon="📈" accent="#06b6d4" spark={sparkData()} />
            </div>

            <SectionCard title="Earnings by Link">
              <div style={{ overflowX: "auto" }}>
                <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr", gap: 8, padding: "0 0 8px", borderBottom: "1px solid #1e293b", marginBottom: 6, minWidth: 500 }}>
                  {["Link", "Clicks", "Conv", "CVR", "Ad Rev", "Your Share"].map((h) => (
                    <div key={h} style={{ fontSize: 9, fontWeight: 700, color: "#475569", letterSpacing: 0.5, textTransform: "uppercase" }}>{h}</div>
                  ))}
                </div>
                {[...links].sort((a, b) => b.userEarnings - a.userEarnings).map((l, i) => {
                  const cvr = l.clicks > 0 ? l.conversions / l.clicks : 0;
                  return (
                    <div key={l.id} style={{
                      display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr", gap: 8,
                      padding: "9px 0", borderBottom: i < links.length - 1 ? "1px solid #0f1a2e" : "none",
                      alignItems: "center", minWidth: 500,
                    }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: "#e2e8f0", fontFamily: "'JetBrains Mono', monospace" }}>/{l.slug}</span>
                        <Badge>{l.tag}</Badge>
                      </div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#94a3b8", fontFamily: "'JetBrains Mono', monospace" }}>{fmtNum(l.clicks)}</div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#94a3b8", fontFamily: "'JetBrains Mono', monospace" }}>{l.conversions}</div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: cvr > 0.04 ? "#22c55e" : cvr > 0.02 ? "#f59e0b" : "#ef4444", fontFamily: "'JetBrains Mono', monospace" }}>{pct(cvr)}</div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#f59e0b", fontFamily: "'JetBrains Mono', monospace" }}>{currency(l.totalAdRevenue)}</div>
                      <div style={{ fontSize: 13, fontWeight: 800, color: "#22c55e", fontFamily: "'JetBrains Mono', monospace" }}>{currency(l.userEarnings)}</div>
                    </div>
                  );
                })}
                <div style={{
                  display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr", gap: 8,
                  padding: "12px 0 4px", borderTop: "1px solid #1e293b", marginTop: 6, minWidth: 500,
                }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#f8fafc" }}>TOTAL</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>{fmtNum(totalClicks)}</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#f1f5f9", fontFamily: "'JetBrains Mono', monospace" }}>{totalConversions}</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#22c55e", fontFamily: "'JetBrains Mono', monospace" }}>{pct(avgCvr)}</div>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#f59e0b", fontFamily: "'JetBrains Mono', monospace" }}>{currency(totalAdRevenue)}</div>
                  <div style={{ fontSize: 14, fontWeight: 900, color: "#22c55e", fontFamily: "'JetBrains Mono', monospace" }}>{currency(totalUserEarnings)}</div>
                </div>
              </div>
            </SectionCard>
          </div>
        )}

        {/* REVENUE SHARE */}
        {tab === "revenue" && (
          <div>
            <SectionCard style={{ marginBottom: 16, border: "1px solid #22c55e30", background: "linear-gradient(135deg, #0f172a 0%, #0a1a0f 100%)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
                }}>🤝</div>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#f8fafc" }}>Revenue Sharing Program</div>
                  <div style={{ fontSize: 12, color: "#22c55e", fontWeight: 600 }}>You keep {pct(REVENUE_SHARE_PCT)} of all ad revenue your links generate</div>
                </div>
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.7 }}>
                Every time someone clicks your shortened link, they see a brief interstitial ad before reaching the destination.
                That ad impression generates revenue — and you keep <strong style={{ color: "#22c55e" }}>60%</strong> of it.
                The more links you create and share, the more you earn. It's that simple.
              </div>
            </SectionCard>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 16 }}>
              <StatCard label="Total Ad Revenue" value={currency(totalAdRevenue)} sub="Generated by your links" icon="📊" accent="#f59e0b" spark={sparkData()} />
              <StatCard label="Your Share (60%)" value={currency(totalUserEarnings)} sub="Available for payout" icon="💰" accent="#22c55e" spark={sparkData()} />
              <StatCard label="Platform Share (40%)" value={currency(totalPlatformEarnings)} sub="Keeps the lights on" icon="🏢" accent="#64748b" />
            </div>

            <SectionCard title="Revenue Split Breakdown" icon="📊" style={{ marginBottom: 16 }}>
              <div style={{ display: "flex", height: 40, borderRadius: 8, overflow: "hidden", marginBottom: 12 }}>
                <div style={{
                  width: `${REVENUE_SHARE_PCT * 100}%`, background: "linear-gradient(90deg, #22c55e, #16a34a)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 13, fontWeight: 800, color: "#020617",
                }}>Your Share · {currency(totalUserEarnings)}</div>
                <div style={{
                  width: `${(1 - REVENUE_SHARE_PCT) * 100}%`, background: "#1e293b",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 12, fontWeight: 700, color: "#64748b",
                }}>Platform · {currency(totalPlatformEarnings)}</div>
              </div>

              {[...links].sort((a, b) => b.totalAdRevenue - a.totalAdRevenue).map((l) => (
                <div key={l.id} style={{ marginBottom: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#94a3b8", marginBottom: 3 }}>
                    <span style={{ fontFamily: "'JetBrains Mono', monospace" }}>/{l.slug}</span>
                    <span>{currency(l.totalAdRevenue)} total → <span style={{ color: "#22c55e", fontWeight: 700 }}>{currency(l.userEarnings)} yours</span></span>
                  </div>
                  <div style={{ display: "flex", height: 8, borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ width: `${REVENUE_SHARE_PCT * 100}%`, background: "#22c55e" }} />
                    <div style={{ width: `${(1 - REVENUE_SHARE_PCT) * 100}%`, background: "#1e293b" }} />
                  </div>
                </div>
              ))}
            </SectionCard>

            <SectionCard title="Payout Status" icon="🏦" style={{ border: "1px solid #f59e0b30" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 14, marginBottom: 14 }}>
                {[
                  { label: "Available Balance", val: currency(totalUserEarnings * 0.4), color: "#22c55e" },
                  { label: "Pending (7-day hold)", val: currency(totalUserEarnings * 0.25), color: "#f59e0b" },
                  { label: "Paid Out", val: currency(totalUserEarnings * 0.35), color: "#64748b" },
                ].map((p) => (
                  <div key={p.label} style={{ background: "#020617", borderRadius: 8, padding: 14, textAlign: "center", border: "1px solid #1e293b" }}>
                    <div style={{ fontSize: 20, fontWeight: 800, color: p.color, fontFamily: "'JetBrains Mono', monospace" }}>{p.val}</div>
                    <div style={{ fontSize: 9, color: "#64748b", marginTop: 4, textTransform: "uppercase", letterSpacing: 0.5 }}>{p.label}</div>
                  </div>
                ))}
              </div>
              <div style={{
                background: "#020617", borderRadius: 8, padding: 14, border: "1px solid #1e293b",
                display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10,
              }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: "#e2e8f0" }}>Minimum payout: $25.00</div>
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>Via PayPal, Stripe, or direct deposit · Paid monthly on the 1st</div>
                </div>
                <button style={{
                  padding: "8px 20px", borderRadius: 8, border: "none",
                  background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                  color: "#020617", fontSize: 12, fontWeight: 700, cursor: "pointer",
                  boxShadow: "0 0 20px #22c55e30",
                }}>Request Payout</button>
              </div>
            </SectionCard>
          </div>
        )}
      </div>

      {/* CREATE MODAL */}
      {showCreate && (
        <div style={{
          position: "fixed", inset: 0, background: "#00000090", backdropFilter: "blur(8px)",
          display: "flex", alignItems: "flex-start", justifyContent: "center", zIndex: 100,
          paddingTop: 30, overflowY: "auto",
        }} onClick={() => setShowCreate(false)}>
          <div onClick={(e) => e.stopPropagation()} style={{
            background: "#0f172a", border: "1px solid #1e293b", borderRadius: 16,
            padding: 28, width: 520, maxWidth: "92vw", marginBottom: 40,
            boxShadow: "0 25px 60px #00000080",
          }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#f8fafc", marginBottom: 4 }}>Create New Link</div>
            <div style={{ fontSize: 11, color: "#64748b", marginBottom: 20 }}>All premium features — rotation, smart redirects, expiry, password protection.</div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Input label="Custom Slug" value={cSlug} onChange={setCSlug} placeholder="best-vpn-deal" mono />
              <Input label="Tag" value={cTag} onChange={setCTag} placeholder="vpn, hosting, ai..." />
            </div>

            {/* Destinations */}
            <div style={{ background: "#020617", border: "1px solid #06b6d430", borderRadius: 10, padding: 16, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#06b6d4" }}>🔄 Destinations {cDests.length > 1 ? `(${cDests.length} URLs — Rotation)` : ""}</div>
                {cDests.length < 5 && (
                  <button onClick={() => setCDests([...cDests, { url: "", label: "", weight: 50 }])} style={{
                    padding: "3px 10px", borderRadius: 4, border: "1px solid #06b6d430",
                    background: "#06b6d410", color: "#06b6d4", fontSize: 10, fontWeight: 700, cursor: "pointer",
                  }}>+ Add URL</button>
                )}
              </div>
              {cDests.map((d, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
                    <div style={{ flex: 3 }}>
                      <Input label={`URL ${i + 1} *`} value={d.url} onChange={(v) => {
                        const n = [...cDests]; n[i].url = v; setCDests(n);
                      }} placeholder="https://product.com/deal?ref=ID" mono />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Input label="Label" value={d.label} onChange={(v) => {
                        const n = [...cDests]; n[i].label = v; setCDests(n);
                      }} placeholder="NordVPN" />
                    </div>
                    {cDests.length > 1 && (
                      <div style={{ flex: 0.6 }}>
                        <Input label="Weight %" value={d.weight} onChange={(v) => {
                          const n = [...cDests]; n[i].weight = v; setCDests(n);
                        }} placeholder="50" type="number" />
                      </div>
                    )}
                    {cDests.length > 1 && (
                      <button onClick={() => setCDests(cDests.filter((_, j) => j !== i))} style={{
                        padding: "6px 8px", borderRadius: 4, border: "none", marginBottom: 14,
                        background: "#ef444420", color: "#ef4444", fontSize: 12, cursor: "pointer",
                      }}>✕</button>
                    )}
                  </div>
                </div>
              ))}
              {cDests.length > 1 && (
                <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                  {["weighted", "sequential", "random"].map((m) => (
                    <button key={m} onClick={() => setCRotation(m)} style={{
                      padding: "4px 12px", borderRadius: 6, border: "1px solid #1e293b", cursor: "pointer",
                      background: cRotation === m ? "#06b6d420" : "transparent",
                      color: cRotation === m ? "#06b6d4" : "#64748b",
                      fontSize: 10, fontWeight: 700, textTransform: "uppercase",
                    }}>{m}</button>
                  ))}
                </div>
              )}
            </div>

            {/* Smart Redirects */}
            <div style={{ background: "#020617", border: `1px solid ${cSmartEnabled ? "#8b5cf630" : "#1e293b"}`, borderRadius: 10, padding: 16, marginBottom: 14 }}>
              <Toggle label="📱 Smart Redirects — Route by device" checked={cSmartEnabled} onChange={setCSmartEnabled} color="#8b5cf6" />
              {cSmartEnabled && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 8 }}>
                  <Input label="Mobile URL" value={cSmartMobile} onChange={setCSmartMobile} placeholder="https://apps.apple.com/..." mono />
                  <Input label="Desktop URL" value={cSmartDesktop} onChange={setCSmartDesktop} placeholder="https://product.com/..." mono />
                </div>
              )}
            </div>

            {/* Expiry */}
            <div style={{ background: "#020617", border: `1px solid ${cExpiryEnabled ? "#f59e0b30" : "#1e293b"}`, borderRadius: 10, padding: 16, marginBottom: 14 }}>
              <Toggle label="⏳ Expiring Link — Self-destruct after limit" checked={cExpiryEnabled} onChange={setCExpiryEnabled} color="#f59e0b" />
              {cExpiryEnabled && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 8 }}>
                  <Input label="Max Clicks" value={cMaxClicks} onChange={setCMaxClicks} placeholder="e.g. 1000" type="number" />
                  <Input label="Expiry Date" value={cExpiryDate} onChange={setCExpiryDate} placeholder="" type="date" />
                </div>
              )}
            </div>

            {/* Password */}
            <div style={{ background: "#020617", border: `1px solid ${cPassword ? "#f59e0b30" : "#1e293b"}`, borderRadius: 10, padding: 16, marginBottom: 18 }}>
              <Input label="🔒 Password Protection (optional)" value={cPassword} onChange={setCPassword} placeholder="Leave blank for no password" />
              {cPassword && (
                <div style={{ fontSize: 11, color: "#f59e0b", marginTop: -6 }}>
                  Visitors will be prompted to enter this password before being redirected.
                </div>
              )}
            </div>

            <div style={{
              background: "#22c55e08", border: "1px solid #22c55e20", borderRadius: 8,
              padding: 12, marginBottom: 18, fontSize: 11, color: "#22c55e",
              display: "flex", alignItems: "center", gap: 8,
            }}>
              💰 You'll earn <strong>60% of all ad revenue</strong> generated by clicks on this link.
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setShowCreate(false)} style={{
                padding: "10px 20px", borderRadius: 8, border: "1px solid #1e293b",
                background: "transparent", color: "#94a3b8", fontSize: 12, fontWeight: 600, cursor: "pointer",
              }}>Cancel</button>
              <button onClick={handleCreate} style={{
                padding: "10px 24px", borderRadius: 8, border: "none",
                background: cDests.some((d) => d.url) ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)" : "#1e293b",
                color: cDests.some((d) => d.url) ? "#020617" : "#475569",
                fontSize: 12, fontWeight: 700, cursor: cDests.some((d) => d.url) ? "pointer" : "default",
                boxShadow: cDests.some((d) => d.url) ? "0 0 20px #22c55e30" : "none",
              }}>Create Link</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
        input::placeholder { color: #334155; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #020617; }
        ::-webkit-scrollbar-thumb { background: #1e293b; border-radius: 3px; }
        * { box-sizing: border-box; }
      `}</style>
    </div>
  );
}